import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { MainLayout } from "../layout/mainLayout";
import { PageTitle } from "../layout/pageTitle";
import { useAppSelector } from "../../framework/redux/hooks";
import { LoadingIndicator } from "../framework/loadingIndicator";
import { useFetchFormTemplates } from "../../hooks/forms/useFetchFormTemplates";

export const FormsView = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const templates = useAppSelector(
        ({ formTemplate }) => formTemplate.templates
    );

    const { error, retry, cooldown } = useFetchFormTemplates(true);

    return (
        <MainLayout topComponent={<PageTitle header={t("forms.title")} />}>
            {!templates && error ? (
                <Box mx={2} mt={4} textAlign="center">
                    <Alert
                        severity="error"
                        action={
                            <Button
                                color="inherit"
                                size="small"
                                disabled={cooldown}
                                onClick={retry}
                                data-testid="forms-retry"
                            >
                                {t("forms.retry")}
                            </Button>
                        }
                    >
                        {t("forms.formsLoadError")}
                    </Alert>
                </Box>
            ) : !templates ? (
                <LoadingIndicator />
            ) : templates.length > 0 ? (
                <List>
                    {templates.map((template) => (
                        <ListItemButton
                            key={template.id}
                            onClick={() => navigate(`/forms/${template.id}`)}
                            data-testid={`form-template-${template.id}`}
                        >
                            <ListItemText primary={template.name} />
                            <ListItemIcon sx={{ minWidth: "auto" }}>
                                <ChevronRight />
                            </ListItemIcon>
                        </ListItemButton>
                    ))}
                </List>
            ) : (
                <Box mx={2} mt={4} textAlign="center">
                    <Typography variant="body2">
                        {t("forms.noForms")}
                    </Typography>
                </Box>
            )}
        </MainLayout>
    );
};
